require('scroll-lock/scroll-lock');

let youTubeApiInitialized = false;
let youTubeApiCallbacks = [];
let vimeoApiInitialized = false;

window.onYouTubeIframeAPIReady = () => {
  youTubeApiCallbacks.forEach(callback => callback());
  youTubeApiCallbacks = [];
};

const withYouTubeAPI = (callback) => {
  if (!youTubeApiInitialized) {
    const script = document.createElement('script');
    script.src = 'https://www.youtube.com/iframe_api';
    document.head.appendChild(script);
    youTubeApiInitialized = true;
    youTubeApiCallbacks.push(callback);
  } else if (youTubeApiCallbacks.length === 0) {
    callback();
  }
};

const initVimeoAPI = () => {
  if (!vimeoApiInitialized) {
    const script = document.createElement('script');
    script.src = 'https://player.vimeo.com/api/player.js';
    document.head.appendChild(script);
    vimeoApiInitialized = true;
  }
};

window.hideVideoPopup = (id) => {
  const videoPopup = document.getElementById(id);
  if (videoPopup instanceof HTMLElement) {
    videoPopup.classList.toggle('video-popup--visible', false);
    const newElement = videoPopup.querySelector('.video-popup__iframe-wrapper').cloneNode(true);
    videoPopup.querySelector('.video-popup__iframe-wrapper').replaceWith(newElement);
  }
};

window.showVideoPopup = (id) => {
  const videoPopup = document.getElementById(id);
  if (videoPopup instanceof HTMLElement) {
    videoPopup.classList.toggle('video-popup--visible', true);
  }
};


const videoPopups = document.querySelectorAll('.video-popup');
Array.from(videoPopups)
  .forEach((videoPopup) => {
    const closeButton = videoPopup.querySelector('video-popup__close-button');
    if (closeButton instanceof HTMLElement) {
      // eslint-disable-next-line no-undef
      closeButton.addEventListener('click', () => hideVideoPopup(videoPopup.id));
    }

    // eslint-disable-next-line no-undef
    videoPopup.addEventListener('click', e => !e.target.closest('.video-popup__iframe-wrapper') && hideVideoPopup(videoPopup.id));
    // eslint-disable-next-line no-undef
    scrollLock(videoPopup);
    const frame = videoPopup.querySelector('.video-popup__iframe');
    if (frame instanceof HTMLElement) {
      const origin = frame.getAttribute('data-origin');

      if (origin === 'youtube') {
        let playOnReady = false;
        let player;
        withYouTubeAPI(() => {
          const onReady = (event) => {
            if (playOnReady) {
              event.target.playVideo();
            }
          };

          // eslint-disable-next-line no-undef
          player = new YT.Player(frame, { events: { onReady } });
        });
        // eslint-disable-next-line no-param-reassign
        videoPopup.play = () => {
          if (player) {
            player.playVideo();
          }
          playOnReady = true;
        };
        // eslint-disable-next-line no-param-reassign
        videoPopup.pause = () => {
          if (player) {
            player.pauseVideo();
          }
          playOnReady = false;
        };
      }
      if (origin === 'vimeo') {
        initVimeoAPI();
        let player;
        // eslint-disable-next-line no-param-reassign
        videoPopup.play = () => {
          if (!player) {
            // eslint-disable-next-line no-undef
            player = new Vimeo.Player(frame);
          }
          player.play();
        };
        // eslint-disable-next-line no-param-reassign
        videoPopup.pause = () => {
          player.pause();
        };
      }
      if (origin === 'loom') {
        console.log("Loom video");
      }
    }
  });
